// Format date for comparison headers
export const formatComparisonDate = (timestamp: Date) => {
  return {
    date: timestamp.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
    time: timestamp.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false }),
  };
};

export function formatDateLabel(isoString: string) {
  const date = new Date(isoString);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
    `${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
}
